import { render, staticRenderFns } from "./TabListItem.vue?vue&type=template&id=59789735"
import script from "./TabListItem.vue?vue&type=script&lang=js"
export * from "./TabListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports